export const LINK_TIP_DETAILS = '/tips/';
export const LINK_TIPS_LIST = '/tips';